var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    fill: "#006A35",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5 C2.44771525,5 2,5.44771525 2,6 L2,11 C2,11.5522847 2.44771525,12 3,12 L15,12 C15.5522847,12 16,11.5522847 16,11 L16,6 C16,5.44771525 15.5522847,5 15,5 L3,5 Z M3,3 L15,3 C16.6568542,3 18,4.34314575 18,6 L18,11 C18,12.6568542 16.6568542,14 15,14 L3,14 C1.34314575,14 2.22044605e-16,12.6568542 0,11 L0,6 C-2.22044605e-16,4.34314575 1.34314575,3 3,3 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.5 L11,8.5 C9.66666667,8.5 9.66666667,6.5 11,6.5 L14,6.5 C15.3333333,6.5 15.3333333,8.5 14,8.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20 L6,20 C5.33333333,20 5.33333333,19 6,19 L12,19 C12.6666667,19 12.6666667,20 12,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17 L6,17 C5.33333333,17 5.33333333,16 6,16 L12,16 C12.6666667,16 12.6666667,17 12,17 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,14 L4,23 C4,23.5522847 3.55228475,24 3,24 C2.44771525,24 2,23.5522847 2,23 L2,13 C2,12.4477153 2.44771525,12 3,12 L15,12 C15.5522847,12 16,12.4477153 16,13 L16,23 C16,23.5522847 15.5522847,24 15,24 C14.4477153,24 14,23.5522847 14,23 L14,14 L4,14 Z",
    id: "Path-2-Copy",
    transform: "translate(9.000000, 18.000000) rotate(180.000000) translate(-9.000000, -18.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,2 L4,4 C4,4.55228475 3.55228475,5 3,5 C2.44771525,5 2,4.55228475 2,4 L2,1 C2,0.44771525 2.44771525,0 3,0 L15,0 C15.5522847,0 16,0.44771525 16,1 L16,4 C16,4.55228475 15.5522847,5 15,5 C14.4477153,5 14,4.55228475 14,4 L14,2 L4,2 Z",
    id: "Path-2-Copy-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a565ac9f0e2758dfb9972b8f9c5d4ebc.svg";
export { ForwardRef as ReactComponent };